import http from "@/utils/request";

// 系统配置  >  审核流程  api

export const diagnosisRange = {
	diagnosisList: function (params) {
		return http.get("/erp/assist/erpTreatmentScopeSet/list", params);
	},
	diagnosisTreeList: function (params) {
		return http.get("/erp/assist/erpTreatmentScopeSet/treeData", params);
	},
	newDiagnosis: function (data) {
		return http.post("/erp/assist/erpTreatmentScopeSet/save", data);
	},
	delDiagnosis: function (params) {
		return http.delete("/erp/assist/erpTreatmentScopeSet/delete", params);
	},
};
